// extracted by mini-css-extract-plugin
module.exports = {"link":"LoginMobileCaptchaItem_link__2nSnI"};